module.exports = __webpack_public_path__ + "img/name_frame_mid_ready.c7b6f7a4.png";